module.exports = __webpack_public_path__ + "static/img/EC.26391bd0.png";